import withSlice from '@screens/SlicesContainer/withSlice';
import DeliveryFeesTable from './DeliveryFeesValuesTable';
import { mapDeliveryFeesValuesTable } from './mapDeliveryFeesValuesTable';

export default withSlice(DeliveryFeesTable, mapDeliveryFeesValuesTable);
